import { Dispatch } from "redux";
import InitialConfigurationApi from "../api/InitialConfigurationApi";
import {
  fetchIsInitialConfigPending,
  fetchIsInitialConfigSuccess,
  fetchIsInitialConfigError,
} from "../redux/actions/InitialConfigurationAction";

export function fetchIsNeedInitialConfiguration() {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(fetchIsInitialConfigPending());
      const [initConfiguration, suiteConfig] = await Promise.all([
        InitialConfigurationApi.getIsNeedInitialConfiguration(),
        InitialConfigurationApi.getCurrentConfiguration(),
      ]);
      dispatch(
        fetchIsInitialConfigSuccess({
          needInitialConfiguration: initConfiguration,
          suite: suiteConfig,
        }),
      );
    } catch (error) {
      dispatch(fetchIsInitialConfigError(error));
    }
  };
}
